import { VueReCaptcha } from "vue-recaptcha-v3";
import RecaptchaVue from "recaptcha-vue";

export default defineNuxtPlugin((nuxtApp) => {
  const { recaptchaV3SiteKey } = useRuntimeConfig().public;
  
  const locale = unref(nuxtApp.$i18n.locale);

  nuxtApp.vueApp.use(VueReCaptcha, {
    siteKey: recaptchaV3SiteKey,
    loaderOptions: { 
      autoHideBadge: false,
      renderParameters: { hl: locale.split("-")[0] },
    },
  });
  nuxtApp.vueApp.use(RecaptchaVue);
});
